import { create } from 'zustand';
import securePersist from '@/utils/securePersist';

interface ProductSlugState {
  rpToken: string | null;
  setRPT: (rpToken: string) => void;
  clearRPT: () => void;
}

export const rptStore = create<ProductSlugState>()(
  securePersist(
    (set) => ({
      rpToken: null,
      setRPT: (rpToken) => set({ rpToken }),
      clearRPT: () => set({ rpToken: null }),
    }),
    { name: 'registrations-promotion-token' },
  ),
);
